module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "cipf"
  }, [_vm._v("Copyright © 1992, 2008 by Ruth Dudley Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Library of Congress Catalog Card Number: 2007942873")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN: 9781590584361 Trade Paperback")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN: 9781615950577 epub")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Poisoned Pen Press")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("6962 E. First Ave., Ste. 103")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Scottsdale, AZ 85251")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poisonedpenpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.poisonedpenpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@poisonedpenpress.com"
    }
  }, [_vm._v("info@poisonedpenpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cipl"
  }, [_vm._v("Disclaimer: The gentlemen’s club to which I belong resembles ffeatherstonehaugh’s in its architecture—emphatically not in its membership or staff.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-265de968","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pppclubbeddeath003.vue
// module id = 63
// module chunks = 0